<template>
	<div>
		<div class='create-post-container'>
			<div class='create-post'>
				<div class='left'>
					<a class='imageWrapper' :href='`/profile/${profile.id}/`' v-if='profile.photo_small'>
						<img :src='profile.photo_small'>
					</a>
				</div>
				<div class='right'>
					<div class='input-wrapper' :class="{'input-wrapper__active':inFocus}">
						<TextareaAutosize
							placeholder='Type something here...'
							v-model='text'
							:min-height='19'
							:max-height='350'
							class='inp'
							@focusin="inFocus=true"
							@focusout="inFocus=false"
						/>
						<SendButton v-if='showSendBtn' @click='createPost()' :disabled="disabled"/>
						<!-- <input type='text'
							v-model='text'
							class='inp'
							:placeholder='`What’s on your mind, ${profile.name}?`'
							v-on:keyup.enter='createPost'
						> -->
					</div>
				</div>
			</div>
			<MediaContainerFile v-model='media' hideButtonAdd :errors='errorsMedia'>
				<MediaTypeFileSlot
					@upload='fileHandle'
					:value='mediaElemFile'
					v-if='media.length < 4'
					class='photo'
				>
					<div>
						<div class="media-button">
							<div class='icon'>
								<svg width='18'
									height='18'
									viewBox='0 0 18 18'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'>
									<path
										d='M2 18H16C16.5304 18 17.0391 17.7893 17.4142 17.4142C17.7893 17.0391 18 16.5304 18 16V2C18 1.46957 17.7893 0.960859 17.4142 0.585786C17.0391 0.210714 16.5304 0 16 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V16C0 16.5304 0.210714 17.0391 0.585786 17.4142C0.960859 17.7893 1.46957 18 2 18ZM5 11L7.363 13.363L11 8L16 15H2L5 11Z'
										fill='#54AE32'/>
								</svg>
							</div>
							<div class='photo-text'>
								Add file or photo
							</div>
						</div>
					</div>
				</MediaTypeFileSlot>
			</MediaContainerFile>
		</div>
	</div>
</template>

<script>
import MediaContainerFile from '__jsVueSections/MediaContainerFile/MediaContainerFile.vue';
import MediaTypeFileSlot from '__jsVueSections/MediaTypeFileSlot/MediaTypeFileSlot.vue';
import TextareaAutosize from '__jsVueSections/TextareaAutosize/TextareaAutosize.vue';
import api from '__jsVueApi';
import SendButton from '../SendButton.vue';

export default {
	name:       'CreatePost',
	components: {
		SendButton,
		MediaContainerFile,
		MediaTypeFileSlot,
		TextareaAutosize,
	},
	props: {
		market: {
			type: [
				String, Number, Boolean
			]
		}
	},
	data() {
		return {
			unKey:         '',
			text:          '',
			media:         [],
			errorsMedia:    [],
			mediaElemFile: {
				id:    false,
				file: {
					src:  false,
					blob: false
				}
			},
			inFocus:  false,
			disabled: false,
		};
	},
	computed: {
		showSendBtn() {
			if (this.text) {
				return true;
			}
			if (this.media.length) {
				for (let i = 0; i < this.media.length; i++) {
					const el = this.media[i];
					if (el?.file) {
						return true;
					}
				}
			}
			return false;
		},
		profile() {
			return this.$store.state.profile.profile;
		},
	},
	watch: {
		media: {
			handler() {
				this.errorsMedia = [];
			},
			deep: true
		},
	},
	methods: {
		createPost() {
			let attachments = [];
			this.media.map((el) => {
				if (el.file) {
					attachments.push({
						filename: el.file.name,
						file:     el.file.file,
					});
				}
			});
			this.disabled = true;
			axios.post(api.posts.create, {
				market:      this.market,
				text:        this.text,
				attachments: attachments,
			}).then((response) => {
				this.media = [];
				this.text = '';
				this.$emit('create', response.data);
			}).catch(error => {
				this.errorsMedia = error.response.data.attachments.map(err => err?.file?.[0]);
			}).finally(() => {
				this.disabled = false;
			});
		},
		fileHandle(file) {
			this.media = [
				...this.media, {
					id:    file.unKey,
					file: {
						file:   file.file,
						name:   file.name,
						format:   file.format,
					}
				}
			];
		},
	}
};
</script>
